import { useMediaQuery } from 'usehooks-ts'

export function useISPWA() {
  const standalone = useMediaQuery('(display-mode: standalone)', {
    defaultValue: true,
  });
  return standalone;
}